import { useMutation } from "@tanstack/react-query"
import { fetcher } from "../fetcher"
import { getDeviceId } from "../../utils/deviceId"

type AccountAddResponse = {
  tokenId: string
  linkToken: string
  expiration: string
}

export function useAccountAdd() {
  return useMutation<AccountAddResponse, unknown, void>({
    mutationFn: async () => {
      const response = await fetcher(
        "/Account/Add",
        {
          method: "POST",
          body: JSON.stringify({
            deviceId: getDeviceId(),
          }),
        },
        {
          useAccessToken: true,
        }
      )

      const responseJson = await response.json()

      return responseJson
    },
    onError: (error) => {
      console.log("error?", error)
    },
  })
}
